import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import ConstElement from '../common/ConstElement';

export default class SearchForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            email: '',
            tel: '',
            client_id: '',
            staff_id: '',
            hiragana_name: '',
            fullname: '',
            date_interview: null,
            created_at: null,
            time_interview: '',
            status: "0",
        }
        this.handleChangeDateInterview = this.handleChangeDateInterview.bind(this);
        this.handleChangeDateCreated = this.handleChangeDateCreated.bind(this);
        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.handleSearchData = this.handleSearchData.bind(this);
        this.resetInputField = this.resetInputField.bind(this);
    }
    
    /**
     * Call search data by text
     */
    handleSearchData() {
        const searchForm = {
            email: this.state.email,
            tel: this.state.tel,
            client_id: this.state.client_id,
            staff_id: this.state.staff_id,
            hiragana_name: this.state.hiragana_name,
            fullname: this.state.fullname,
            date_interview: this.state.date_interview ? this.state.date_interview.format("YYYY-MM-DD") : '',
            created_at: this.state.created_at ? this.state.created_at.format("YYYY-MM-DD") : '',
            time_interview: this.state.time_interview,
            status: this.state.status,
        };
        if (typeof this.props.onSearch === 'function') {
            this.props.onSearch(searchForm);
        }
    }
    
    /**
     * Process change date interview
     */
    handleChangeDateInterview(date) {
        this.setState({
          date_interview: date,
        });
    }
    
    /**
     * Process change date create at
     */
    handleChangeDateCreated(date) {
        this.setState({
          created_at: date,
        });
    }
    
    /**
     * Process field change
     */
    handleFieldChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        }) 
    }
    
    /**
     * Clear data input field
     */
    resetInputField() {
        this.setState({
            email: '',
            tel: '',
            client_id: '',
            staff_id: '',
            hiragana_name: '',
            fullname: '',
            date_interview: null,
            created_at: null,
            time_interview: '',
            status: '0',
        });
    }
    
    render() {
        return(
            <div className="collapse multi-collapse" id="search-approval">
                <div className="card mt-3">
                    <div className="card-header">面接情報を検索する条件</div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-sm-3">
                                <div className="form-group">
                                    <label className="form-label" htmlFor="">面接日</label>
                                    <div className="input-group">
                                        <DatePicker
                                            locale="ja-JP"
                                            className="form-control form_datepicker"
                                            dateFormat="YYYY/MM/DD"
                                            selected={this.state.date_interview}
                                            onChange={this.handleChangeDateInterview}
                                            placeholderText="面接日"
                                            disabledKeyboardNavigation
                                        />
                                        <div className="input-group-append">
                                            <button className="btn btn-outline-secondary" type="button" id="form-calendar"><i className="material-icons">calendar_today</i></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-3">
                                <div className="form-group">
                                    <label className="form-label" htmlFor="">面接時間</label>
                                    <ConstElement onElementChange={this.handleFieldChange} element ="time_interview" value={this.state.time_interview ? this.state.time_interview : ''} />
                                </div>
                            </div>
                            <div className="col-sm-3">
                                <div className="form-group">
                                    <label className="form-label" htmlFor="">登録日</label>
                                    <div className="input-group">
                                        <DatePicker
                                            locale="ja-JP"
                                            className="form-control form_datepicker"
                                            dateFormat="YYYY/MM/DD"
                                            selected={this.state.created_at}
                                            onChange={this.handleChangeDateCreated}
                                            placeholderText="登録日"
                                            disabledKeyboardNavigation
                                        />
                                        <div className="input-group-append">
                                            <button className="btn btn-outline-secondary" type="button" id="form-calendar"><i className="material-icons">calendar_today</i></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-3">
                                <div className="form-group">
                                    <label className="form-label" htmlFor="">依頼者ID</label>
                                    <input type="text" name="client_id" onChange={this.handleFieldChange} value={this.state.client_id} className="form-control" placeholder="依頼者ID"/>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-3">
                                <div className="form-group">
                                    <label className="form-label" htmlFor="">ワーカーID</label>
                                    <input type="text" name="staff_id" onChange={this.handleFieldChange} value={this.state.staff_id} className="form-control" placeholder="ワーカーID"/>
                                </div>
                            </div>
                            <div className="col-sm-3">
                                <div className="form-group">
                                    <label className="form-label" htmlFor="">お名前（カナ）</label>
                                    <input type="text" name="hiragana_name" onChange={this.handleFieldChange} value={this.state.hiragana_name} className="form-control" placeholder="お名前（カナ）"/>
                                </div>
                            </div>
                            <div className="col-sm-3">
                                <div className="form-group">
                                    <label className="form-label" htmlFor="">お名前</label>
                                    <input type="text" name="fullname" onChange={this.handleFieldChange} value={this.state.fullname} className="form-control" placeholder="お名前"/>
                                </div>
                            </div>
                            <div className="col-sm-3">
                                <div className="form-group">
                                    <label className="form-label" htmlFor="">電話番号</label>
                                    <input type="text" name="tel" onChange={this.handleFieldChange} value={this.state.tel} className="form-control" placeholder="電話番号"/>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-3">
                                <div className="form-group">
                                    <label className="form-label" htmlFor="">メール</label>
                                    <input type="text" className="form-control" name="email" placeholder="メール" onChange={this.handleFieldChange} value={this.state.email}/>
                                </div>
                            </div>
                            <div className="col-sm-3">
                                <div className="form-group">
                                    <label className="form-label" htmlFor="">ステータス</label>
                                    <select className="form-control" name="status" value={this.state.status} onChange={this.handleFieldChange}>
                                        <option value="all">全て</option>
                                        <option value="0">未承認</option>
                                        <option value="1">承認</option>
                                        <option value="8">アカウント停止</option>
                                        <option value="9">否認</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button type="reset" className="btn btn-light" onClick={this.resetInputField}>リセット</button>
                        <button onClick={this.handleSearchData} type="submit" className="btn btn-secondary">検索する</button>
                    </div>
                </div>
            </div>
        );
    }
}